// extracted by mini-css-extract-plugin
export default {"referalItem":"CopyInHashButton_referalItem__0Yisu","referalLabel":"CopyInHashButton_referalLabel__EqUoa"};